import { Fragment, useCallback } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H3 from 'UIComponents/elements/headings/H3';
import UIList from 'UIComponents/list/UIList';
import UIIcon from 'UIComponents/icon/UIIcon';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HUBSPOT_USER_GUIDE_LINK_THEME = 'https://knowledge.hubspot.com/website-pages/use-themes';
const HUBSPOT_USER_GUIDE_LINK_MODULE = 'https://knowledge.hubspot.com/website-pages/edit-page-content-in-a-drag-and-drop-area';
const NoopExternalIcon = () => null;
const ExternalLink = props => /*#__PURE__*/_jsx(UILink, Object.assign({}, props, {
  ExternalIcon: NoopExternalIcon,
  external: true
}));
export default function AssetResources({
  casesUrl,
  forumUrl,
  getAssetEventSelectorId = () => '',
  offeringType = 'THEME',
  onTrackInteraction,
  setupUrl,
  supportUrl
}) {
  const trackInteraction = useCallback(value => {
    if (onTrackInteraction) {
      onTrackInteraction(value);
    }
  }, [onTrackInteraction]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(H3, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-assets-core.details.resources.title"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [/*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-SETUP-GUIDE'),
        href: setupUrl,
        onClick: () => trackInteraction('click setup guide link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lesson"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.resources.setupUrl"
        })]
      }), /*#__PURE__*/_jsxs(ExternalLink, {
        href: offeringType === 'THEME' ? HUBSPOT_USER_GUIDE_LINK_THEME : HUBSPOT_USER_GUIDE_LINK_MODULE,
        onClick: () => trackInteraction('click user guide link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lesson"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.resources.userGuide"
        })]
      }), supportUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-SUPPORT-WEBSITE'),
        href: supportUrl,
        onClick: () => trackInteraction('click support website link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "website"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.resources.supportUrl"
        })]
      }), forumUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-COMMUNITY'),
        href: forumUrl,
        onClick: () => trackInteraction('click community link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "lists"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.resources.forumUrl"
        })]
      }), casesUrl && /*#__PURE__*/_jsxs(ExternalLink, {
        "data-hs-analytics-id": getAssetEventSelectorId('SIDEBAR-CASE-STUDY'),
        href: casesUrl,
        onClick: () => trackInteraction('click case study link'),
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "book"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-assets-core.details.resources.casesUrl"
        })]
      })]
    })]
  });
}